import { __awaiter, __decorate } from "tslib";
import { Component, HostListener, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from "@angular/router";
import { ComponentService } from "../../../services/component.service";
import { AuthenticationWalletModalComponent } from "../authentication-wallet-modal/authentication-wallet-modal.component";
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from "../../../services/http-client.service";
import { QrScannerModalService } from "../../qr-scanner-modal/qr-scanner-modal.service";
import { UtilityService } from "../../../services/utility.service";
import { WebClientService } from "../../../services/webclient-settings.service";
import { validateIBAN } from 'ngx-iban-validator';
import { CheckProtocolModalWalletComponent } from "../check-protocol-modal-wallet/check-protocol-modal-wallet.component";
import { AddAddressToWhitelistModalComponent } from "../add-address-to-whitelist-modal/add-address-to-whitelist-modal.component";
import { LimitExceededModalWalletComponent } from "../limit-exceeded-modal-wallet/limit-exceeded-modal-wallet.component";
import { BankaccountWhitelistInfoComponent } from "../bankaccount-whitelist-info/bankaccount-whitelist-info.component";
/**
 * Withdraw Wallet Modal Component
 */
let WithdrawWalletModalComponent = class WithdrawWalletModalComponent {
    constructor(sanitizer, router, httpClient, webSettingsService, compService, location, qrScannerService, themeService, utilityService) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.httpClient = httpClient;
        this.webSettingsService = webSettingsService;
        this.compService = compService;
        this.location = location;
        this.qrScannerService = qrScannerService;
        this.themeService = themeService;
        this.utilityService = utilityService;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.amount = null;
        this.minAmount = 0;
        this.maxAmount = 0;
        this.address = '';
        this.maxValidAmount = true;
        this.minValidAmount = true;
        this.validAddress = true;
        this.sendButtonDisabled = true;
        this.fixedFee = 0;
        this.minBalance = false;
        this.bankAccount = '';
        this.bankAccountsExpanded = false;
        this.validBankAccount = true;
        this.bankAccountAvailable = true;
        this.acceptOwnNameAndAccount = false;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.addressForScreen = '';
        this.addressName = '';
        this.addressVerboseId = '';
        this.screenWidth = window.innerWidth;
        this.ecurrencyChains = [];
        this.selectedChain = '';
        this.activeChains = false;
        this.whitelistedAddressesExpanded = false;
        this.whitelistedAddresses = [];
        this.whitelistedAddressesFilteredByChain = {};
        this.isAddressInternal = false;
        this.userTypeLite = 'lite_verified';
        this.liteLimitExceeded = false;
        this.liteLimitChecked = true;
        this.statusApproved = 'APPROVED';
        this.waitingForApprovalStatus = 'WAITING_FOR_APPROVAL';
        this.memo = '';
        this.validMemo = true;
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.data.walletData.currency.fiat) {
                this.getMarketSettings(false).then(() => this.checkMinBalance());
                this.httpClient.get('user/getbankaccounts').subscribe((result) => {
                    this.bankAccounts = result;
                    this.bankAccounts = this.bankAccounts.filter(bankAccount => bankAccount.status === this.statusApproved);
                });
            }
            else {
                this.httpClient.get('market/order/get_ecurrency_chains?currency=' + this.data.walletData.currency.verboseId).subscribe((result) => {
                    this.ecurrencyChains = result['chains'];
                    this.numOfChains = result['num_of_chains'];
                    if (this.ecurrencyChains.length === 1) {
                        this.chainForOrder = this.ecurrencyChains[0];
                    }
                });
                this.getWhitelistedAddresses();
            }
            this.intervalId = setInterval(() => {
                this.getWallet();
            }, 15000);
        });
    }
    ngOnDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
    close() {
        this.modal.destroy();
    }
    openChainsSelect() {
        this.activeChains = !this.activeChains;
        this.whitelistedAddressesExpanded = false;
    }
    fillChainData(data) {
        this.selectedChain = data.chain.name + ' - ' + data.chain.description;
        this.chainForOrder = data;
        this.whitelistedAddressesFilteredByChain = this.whitelistedAddresses.filter(address => address.chainVerboseId === data.chain.name);
        this.activeChains = false;
        this.address = '';
        this.addressName = '';
        this.addressForScreen = '';
        this.amountReceive = null;
        this.amount = null;
        this.fee = null;
        this.acceptOwnNameAndAccount = false;
        this.minValidAmount = true;
        this.maxValidAmount = true;
        this.sendButtonDisabled = true;
    }
    checkValidation(calculateAmountForDifferentAddress = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.data.walletData.currency.fiat && (this.amount && this.amount !== this.previousAmount) && !calculateAmountForDifferentAddress) {
                this.previousAmount = this.amount;
                const data = yield this.httpClient.get('wallet/isaddressinternal?address=' + this.address + '&cryptocurrency=' + this.data.walletData.currency.verboseId + '&amount=' + this.amount + '&chain=' + this.chainForOrder['chain']['name'] + '&isAddressInternalChecked=true').toPromise();
                this.internalFee = data['internalFee'];
                this.externalFee = data['externalFee'];
                this.fixedFee = this.isAddressInternal ? this.internalFee : this.externalFee;
                this.fee = this.fixedFee;
            }
            else if (this.amount && calculateAmountForDifferentAddress) {
                this.fixedFee = this.isAddressInternal ? this.internalFee : this.externalFee;
                this.fee = this.fixedFee;
            }
            if (this.minBalance) {
                return;
            }
            if (this.data.walletData.currency.usingMemo) {
                if (!this.memo) {
                    this.sendButtonDisabled = true;
                    return;
                }
                else {
                    if (!this.validateMemo()) {
                        this.sendButtonDisabled = true;
                        return;
                    }
                }
            }
            if (!this.amount || typeof this.amount === 'undefined' || this.amount <= 0) {
                this.minValidAmount = true;
                this.maxValidAmount = true;
                this.amountReceive = null;
                this.fee = null;
                this.sendButtonDisabled = true;
                return;
            }
            if (!this.data.walletData.currency.fiat) {
                if (this.amount && this.amount.toString().split('.').length > 1 && this.amount.toString().split('.')[1].length > 8) {
                    this.amount = Number(this.utilityService.truncateDataBasedOnPrecision(this.amount, 18));
                }
            }
            else {
                if (this.amount && this.amount.toString().split('.').length > 1 && this.amount.toString().split('.')[1].length > 2) {
                    this.amount = Number(this.utilityService.truncateDataBasedOnPrecision(this.amount, 2));
                }
                yield this.getFiatFees(this.amount, this.data.walletData.currency.verboseId.toLowerCase());
            }
            if (this.amount * 100000000 < this.minAmount * 100000000) {
                this.minValidAmount = false;
                this.maxValidAmount = true;
                this.amountReceive = null;
                this.sendButtonDisabled = true;
                this.fee = null;
                return;
            }
            if (this.amount * 100000000 > this.data.walletData.spendableTotal * 100000000 || this.amount * 100000000 > this.maxAmount * 100000000) {
                this.maxValidAmount = false;
                this.minValidAmount = true;
                this.amountReceive = null;
                this.sendButtonDisabled = true;
                this.fee = null;
                return;
            }
            this.maxValidAmount = true;
            this.minValidAmount = true;
            this.fee = parseFloat(String(this.fixedFee));
            this.amountReceive = this.sub(this.amount, this.fixedFee);
            if (!this.data.walletData.currency.fiat) {
                this.sendButtonDisabled = !this.validAddress;
            }
            else {
                this.validBankAccount = true;
                this.bankAccountAvailable = true;
                if (!this.bankAccount || this.bankAccount === '') {
                    this.sendButtonDisabled = true;
                    return;
                }
                this.sendButtonDisabled = false;
            }
            if (!this.acceptOwnNameAndAccount) {
                this.sendButtonDisabled = true;
                return;
            }
        });
    }
    sendCoinsOrFiat() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.sendButtonDisabled || this.minBalance) {
                return;
            }
            if (this.data.walletData.currency.fiat) {
                yield this.validateBankAccount();
                if (this.validBankAccount) {
                    this.bankAccountAvailable = yield this.checkBankAccountAvailability();
                }
                if (!this.validBankAccount || !this.bankAccountAvailable) {
                    this.sendButtonDisabled = true;
                    return;
                }
            }
            else {
                if (this.user.user_type_id.type === this.userTypeLite) {
                    this.liteLimitChecked = false;
                    this.liteLimitExceeded = yield this.checkIfLiteLimitIsExceeded();
                    if (this.liteLimitExceeded) {
                        this.close();
                        this.compService.openModal(LimitExceededModalWalletComponent);
                        return;
                    }
                }
            }
            const withdrawData = {
                customerWalletId: this.data.walletData.verboseId,
                amount: this.amount,
                amountReceive: this.amountReceive,
                toAddress: this.data.walletData.currency.fiat ? this.bankAccount : this.addressVerboseId,
                passphrase: this.data.walletData.passphrase,
                currency: this.data.walletData.currency.verboseId,
                chain: this.data.walletData.currency.fiat ? undefined : this.chainForOrder.chain.name,
                memo: this.data.walletData.currency.usingMemo ? this.memo : undefined
            };
            this.close();
            if (this.ecurrencyChains.length > 1) {
                this.compService.openModal(CheckProtocolModalWalletComponent, {
                    selectedChain: this.chainForOrder,
                    accountData: this.data.accountData,
                    walletData: this.data.walletData,
                }, (success) => {
                    this.openAuthenticationModal(withdrawData);
                });
            }
            else {
                this.openAuthenticationModal(withdrawData);
            }
        });
    }
    openAuthenticationModal(withdrawData) {
        this.compService.openModal(AuthenticationWalletModalComponent, {
            withdrawData,
            accountData: this.data.accountData,
            walletData: this.data.walletData,
            authenticated: false,
            isFiat: this.data.walletData.currency.fiat,
            type: this.data.walletData.currency.fiat ? 'fiat_withdrawal' : 'crypto_withdrawal',
        });
    }
    getMaxAmount() {
        if (this.address !== '' || this.data.walletData.currency.fiat) {
            this.amount = this.data.walletData.spendableTotal;
            this.checkValidation();
        }
    }
    getWallet() {
        this.httpClient.get('wallet/getwallet?customerWalletId=' + this.data.walletData.verboseId).subscribe((data) => {
            if (data['wallet']) {
                this.data.walletData.spendableTotal = data['wallet']['spendableTotal'];
            }
        });
    }
    validateBankAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.data.walletData.currency.verboseId === 'EUR') {
                this.validBankAccount = !validateIBAN({
                    value: this.bankAccount,
                }).ibanInvalid;
            }
            else {
                yield this.utilityService.validateBankAccount(this.bankAccount).then(result => {
                    this.validBankAccount = result.validBankAccount;
                    this.bankAccount = result.formatedBankAccount;
                });
            }
        });
    }
    checkMinBalance() {
        this.minBalance = this.data.walletData.spendableTotal * 100000000 < this.minAmount * 100000000;
    }
    getMarketSettings(isInternal = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let userType = this.user.user_type_id.type;
            let isIndividual = this.user.is_company_user ? 0 : 1;
            let meansOfPayment = 'bank_slip';
            let orderType = isInternal ? 'internal_wallet_withdrawal' : 'wallet_withdrawal';
            const chainName = this.ecurrencyChains.length > 1 ? this.chainForOrder['chain']['name'] : '';
            let data = yield this.httpClient.get('wallet/getmarketsettings?baseCurrency=' + this.data.walletData.currency.verboseId.toLowerCase() + '&meanOfPayment=' + meansOfPayment + '&userType=' + userType + '&orderType=' + orderType + '&isIndividual=' + isIndividual + (chainName ? '&chain=' + chainName : '')).toPromise();
            this.minAmount = Number(data['min_amount']);
            this.maxAmount = Number(data['max_amount']);
        });
    }
    getFiatFees(amount, currency) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield this.httpClient.get('wallet/fiatfees?amount=' + amount + '&currency=' + currency).toPromise();
            this.fixedFee = data['externalFee'];
        });
    }
    getWhitelistedAddresses() {
        this.httpClient.get('wallet/whitelist').subscribe((data) => {
            this.whitelistedAddresses = data['message'].filter(address => address.currency.startsWith(this.data.walletData.currency.verboseId) && address.validated);
        });
    }
    expandWhitelistedAddresses() {
        if (!this.selectedChain && this.ecurrencyChains.length > 1) {
            return;
        }
        this.whitelistedAddressesExpanded = !this.whitelistedAddressesExpanded;
        this.activeChains = false;
    }
    fillAddress(address) {
        this.address = address.address;
        this.addressName = address.name;
        this.addressVerboseId = address.verboseId;
        this.addressForScreen = this.showAddressWithEllipsis(this.addressName, this.address);
        this.validateAddress(address);
    }
    validateAddress(address) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.webSettingsService.applySettings('WALLET.WHITELIST_ADDRESS.USER_INFO_MANDATORY') &&
                !((address.firstName && address.lastName && address.addressLine) || (address.addressLine && address.companyName))) {
                this.addAddressToWhitelist(address, true);
            }
            if (this.address) {
                if (this.webSettingsService.applySettings('ADDRESS_VALIDATION')) {
                    yield this.utilityService.validateAddress(this.address, this.data.walletData.currency.verboseId, this.chainForOrder ? this.chainForOrder['chain']['name'] : null).then(result => {
                        this.validAddress = result.validDepositAddress;
                    });
                }
                else {
                    this.validAddress = true;
                }
                if (this.address !== '' && this.address !== this.previousAddress && this.validAddress) {
                    this.httpClient.get('wallet/isaddressinternal?address=' + this.address + '&cryptocurrency=' + this.data.walletData.currency.verboseId + '&amount=' + this.amount + '&chain=' + this.chainForOrder['chain']['name'] + '&isAddressInternalChecked=false').subscribe((data) => __awaiter(this, void 0, void 0, function* () {
                        this.isAddressInternal = !!data['addressInternal']['internal'];
                        this.checkValidation(true);
                        yield this.getMarketSettings(this.isAddressInternal);
                        this.checkMinBalance();
                        this.previousAddress = this.address;
                    }));
                }
            }
        });
    }
    addAddressToWhitelist(address = null, updateExistingAddress = false) {
        this.close();
        this.compService.openModal(AddAddressToWhitelistModalComponent, {
            updateExistingAddress,
            address,
            walletData: this.data.walletData,
            accountData: this.data.accountData,
            ecurrencyChains: this.ecurrencyChains,
            selectedChain: this.chainForOrder
        });
    }
    sub(b, c) {
        let tens = [10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000, 10000000000, 100000000000, 1000000000000, 10000000000000, 100000000000000, 1000000000000000, 10000000000000000, 100000000000000000, 1000000000000000000];
        let finalString;
        let b1 = b.toString().split(".");
        let b1_max = 0;
        if (b1.length == 2) {
            b1_max = b1[1].length;
        }
        let c1 = c.toString().split(".");
        let c1_max = 0;
        if (c1.length == 2) {
            c1_max = c1[1].length;
        }
        let max_len = 0;
        let max_val = 0;
        if (b1_max > c1_max) {
            max_val = tens[b1_max - 1];
            max_len = b1_max;
        }
        else {
            max_len = c1_max;
            max_val = tens[c1_max - 1];
        }
        let fv = 0;
        if (max_len == 0) {
            max_val = 1;
            fv = b - c;
        }
        else {
            const precisionFactor = Math.pow(10, c1_max);
            finalString = Math.floor((b - c) * precisionFactor) / precisionFactor;
            return finalString;
        }
        finalString = fv.toString();
        return finalString;
    }
    onResize(event) {
        this.screenWidth = event.target.innerWidth;
        this.addressForScreen = this.showAddressWithEllipsis(this.addressName, this.address);
    }
    showAddressWithEllipsis(name, address) {
        const maxNumOfCharacters = 43;
        let addressNameLength = name.length;
        let addressFormatted;
        if (addressNameLength > maxNumOfCharacters / 2) {
            addressNameLength = maxNumOfCharacters / 2;
        }
        if (this.screenWidth < 600) {
            addressFormatted = address.substr(0, 5) + '...' + address.substr(address.length - 5, address.length);
        }
        else {
            const allowedLength = maxNumOfCharacters - addressNameLength;
            if (address.length > allowedLength) {
                addressFormatted = address.substr(0, allowedLength / 2 - 2) + '...' + address.substr(address.length - (allowedLength / 2 - 2), address.length);
            }
            else {
                addressFormatted = address;
            }
        }
        return addressFormatted;
    }
    checkBankAccountAvailability() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.httpClient.post('wallet/checkbankaccountavailability', { bankAccount: this.bankAccount }).toPromise();
            return data['bankAccountAvailable'];
        });
    }
    checkIfLiteLimitIsExceeded() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.httpClient.get('wallet/litelimitexceeded?currency=' + this.data.walletData.currency.verboseId + '&amount=' + this.amount).toPromise();
            this.liteLimitChecked = true;
            return data['message'];
        });
    }
    dontChangeValueOfCheckbox() {
        this.acceptOwnNameAndAccount = !this.acceptOwnNameAndAccount;
    }
    expandBankAccounts() {
        this.bankAccountsExpanded = !this.bankAccountsExpanded;
    }
    fillBankAccount(bankAccount) {
        this.bankAccount = bankAccount.bank_account;
        this.checkValidation();
    }
    addNewBankAccount() {
        this.close();
        this.compService.openModal(BankaccountWhitelistInfoComponent, {
            pendingProcess: this.bankAccounts.some(account => account.status === this.waitingForApprovalStatus),
        });
    }
    validateMemo() {
        if (this.data.walletData.currency.verboseId.toUpperCase() === 'XRP') {
            this.validMemo = /^[0-9]+$/.test(this.memo);
        }
        else {
            this.validMemo = /^[a-zA-Z0-9]+$/.test(this.memo);
        }
        return this.validMemo;
    }
};
WithdrawWalletModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: SharedHttp },
    { type: WebClientService },
    { type: ComponentService },
    { type: LocationStrategy },
    { type: QrScannerModalService },
    { type: WebsiteThemeService },
    { type: UtilityService }
];
__decorate([
    HostListener('window:resize', ['$event'])
], WithdrawWalletModalComponent.prototype, "onResize", null);
WithdrawWalletModalComponent = __decorate([
    Component({
        selector: 'ecd-withdraw-wallet-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./withdraw-wallet-modal.component.html")).default
    })
], WithdrawWalletModalComponent);
export { WithdrawWalletModalComponent };
